var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("还剩："),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(this.countdown.hours)+":"+_vm._s(this.countdown.minutes)+":"+_vm._s(this.countdown.seconds))])])])}
var staticRenderFns = []

export { render, staticRenderFns }